/**
 * Core application constants.
 * Use these constants instead of hardcoding strings across the application.
 */

export const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://kavithai.de';
export const CONTACT_EMAIL = 'support@kavithai.de';
export const SITE_NAME = 'Kavithai.de';
export const DEFAULT_LANGUAGE = 'ta';
export const LANGUAGES = ['ta', 'de', 'en'];

export const STORAGE_KEYS = {
  AUTHENTICATED: 'kavithai_authenticated',
  USER: 'kavithai_user',
  TOKEN: 'kavithai_token',
  REFRESH_TOKEN: 'kavithai_refresh_token',
  TOKEN_EXPIRY: 'kavithai_token_expiry',
  THEME: 'kavithai_theme',
};

export const OAUTH_CONFIG = {
  CALLBACK_PATH: '/oauth2/callback',
  LOGOUT_PATH: '/logout',
};
